import { noop } from '@mindtickle/utils';
import { AdvanceLinkProps } from '../../type';

const ExternalLink = ({ url, children, className, onClick = noop }: AdvanceLinkProps) => (
  <a href={url} target="_blank" className={className} rel="noopener noreferrer" onClick={onClick}>
    {children}
  </a>
);

export default ExternalLink;
